import React, { useState, useEffect } from "react";
import {
  addToCart,
  getCart,
  updateCartItem,
  removeCartItem,
  clearCart,
  checkoutCart,
} from "../../api/cartApi";
import { AiOutlineExport } from "react-icons/ai";
import { IoBagHandleOutline } from "react-icons/io5";
import { MdArrowBackIosNew, MdArrowForwardIos } from "react-icons/md";

const products = [
  {
    id: 1,
    image:
      "https://images.unsplash.com/photo-1497436072909-60f360e1d4b1?auto=format&fit=crop&w=800&q=80",
    title: "Adidas 4D X Parley Running Shoes",
    oldPrice: 444.0,
    price: 333.2,
    discount: 12,
  },
  {
    id: 2,
    image:
      "https://images.unsplash.com/photo-1520340277366-7d2a4dfddecb?auto=format&fit=crop&w=800&q=80",
    title: "Nike Sport Shoes",
    oldPrice: 300.0,
    price: 250.0,
    discount: 15,
  },
  {
    id: 3,
    image:
      "https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f?auto=format&fit=crop&w=800&q=80",
    title: "Puma Classic Sneakers",
    oldPrice: 320.0,
    price: 289.0,
    discount: 10,
  },
  {
    id: 4,
    image:
      "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=800&q=80",
    title: "Reebok Workout Plus",
    oldPrice: 350.0,
    price: 310.0,
    discount: 8,
  },
  {
    id: 5,
    image:
      "https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f?auto=format&fit=crop&w=800&q=80",
    title: "Asics Gel Nimbus",
    oldPrice: 280.0,
    price: 245.0,
    discount: 12,
  },
];

export default function ProductCarousel() {
  const [current, setCurrent] = useState(0);
  const itemsToShow = 3;

  const nextSlide = () => setCurrent((prev) => (prev + 1) % products.length);
  const prevSlide = () =>
    setCurrent((prev) => (prev - 1 + products.length) % products.length);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrent((prev) => (prev + 1) % products.length);
  //   }, 4000);
  //   return () => clearInterval(interval);
  // }, []);

  // Get visible products in window view
  const visibleProducts = products
    .slice(current, current + itemsToShow)
    .concat(
      current + itemsToShow > products.length
        ? products.slice(0, (current + itemsToShow) % products.length)
        : []
    );

  // Example: Get cart items on mount
  useEffect(() => {
    // Uncomment to fetch cart items on load
    // getCart().then(console.log);
  }, []);

  // Add to Cart handler
  const handleAddToCart = async (productId) => {
    const res = await addToCart(productId, 1, 0);
    alert(res.message || "Item added to cart");
  };

  // Example: Update, remove, clear, checkout
  // updateCartItem(itemId, newQty, newVariantId).then(console.log);
  // removeCartItem(itemId).then(console.log);
  // clearCart().then(console.log);
  // checkoutCart(payment_method, payment_method_id, shipping_address).then(console.log);

  return (
    <div className="mt-5 w-full">
      {/* Header */}
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold border-b-2 border-red-500 text-red-500">
          Watch Now & Shop Live{" "}
        </h2>
        <div className="flex gap-3">
          <button className="border-2 text-md border-green-300 px-3 py-2  bg-green-100 rounded-full">
            View All
          </button>
          <button
            onClick={prevSlide}
            className="border-2 border-green-300 px-3 py-2  bg-green-100 rounded-full"
          >
            <MdArrowBackIosNew />
          </button>
          <button
            onClick={nextSlide}
            className="border-2 border-green-300 px-3 py-2  bg-green-100 rounded-full"
          >
            <MdArrowForwardIos />
          </button>
        </div>
      </div>

      {/* Product carousel */}
      <div className="relative overflow-hidden mt-4">
        <div className="flex justify-center items-center gap-4">
          {visibleProducts.map((product) => (
            <div
              key={product.id}
              className="w-full h-64 rounded bg-cover bg-center relative"
              style={{ backgroundImage: `url(${product.image})` }}
            >
              {/* Top-left overlay */}
              <span className="absolute top-2 left-2 text-white text-xs font-semibold px-2 py-1 rounded-xl">
                <div className="flex gap-3 p-2 bg-[#D9D9D980] rounded-3xl">
                  <div className="bg-white p-2 w-[30px] h-[30px] rounded-full">
                    <img
                      src="/image/wanchain.png"
                      alt="logo"
                      className="w-[20px] h-[20px] object-contain"
                    />
                  </div>
                  <div className="text-black">
                    <p className="font-semibold text-[12px]">SKY Products</p>
                    <p className="text-[9px]">27 Jan 2025, 12:30 PM</p>
                  </div>
                </div>
              </span>

              {/* Inner product card */}
              <div className="absolute bottom-3 -right-2  w-[160px] h-[230px] bg-white rounded shadow-lg">
                <div className="relative bg-[#dadadc] rounded">
                  <img
                    src={"/image/shoeimg.png"}
                    alt={product.title}
                    className="w-full h-[120px] object-contain rounded-md"
                  />
                  {product.discount && (
                    <span className="absolute top-2 left-2 bg-red-600 text-white text-xs px-2 py-1 rounded">
                      {product.discount}% OFF
                    </span>
                  )}
                </div>

                <div>
                  <p className=" p-2 text-sm  uppercase">{product.title}</p>

                  <div className="flex px-2 justify-between items-center ">
                    <div className="flex flex-col">
                      <span className="line-through text-gray-400 text-[10px]">
                        ${product.oldPrice.toFixed(2)}
                      </span>
                      <span className="text-black font-semibold">
                        ${product.price.toFixed(2)}
                      </span>
                    </div>
                    <button
                      className="flex items-center justify-center bg-gray-900 text-white rounded-full p-2"
                      onClick={() => handleAddToCart(product.id)}
                    >
                      <IoBagHandleOutline className="text-[12px]" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Dots */}
        <div className="flex space-x-2 justify-start mt-4">
          {products.map((_, idx) => (
            <span
              key={idx}
              className={`h-2 w-2 rounded-full focus:outline-none transition-colors ${
                current === idx ? "bg-green-600 w-[20px]" : "bg-gray-300"
              }`}
            ></span>
          ))}
        </div>
      </div>
    </div>
  );
}
